// get all users
export const getAllLenders = (filters) => ({
  url: "/admin/lenders",
  method: "GET",
  params: filters,
});

// get single user
export const getSingleLender = (id) => ({
  url: `/admin/lender/${id}`,
  method: "GET",
});

// toggle activation of user account
export const toggleLenderActivation = (id) => ({
  url: `/admin/lender-status/${id}`,
  method: "POST",
});

// delete user account
export const deleteLender = (id) => ({
  url: `/admin/lender/${id}`,
  method: "DELETE",
});
